import Card from '@/components/common/Card';
import { CheckoutContext } from '@/contexts/CheckoutContext';
import useDevice from '@/hooks/useDevice';
import useSettings from '@/hooks/useSettings';
import { useContext, useEffect } from 'react';
import Confetti from 'react-confetti';
import BoletoPayment from './BoletoPayment';
import PicPayPayment from './PicPayPayment';
import PixPayment from './PixPayment';
import PixAutoPayment from './PixAutoPayment';

const WaitingPayment = () => {
  const { firstPayment, checkPayment, checkingPayment } = useContext(CheckoutContext);
  const { device } = useDevice();
  const settings = useSettings();

  if (!firstPayment) {
    return null;
  }

  const handleCheckPayment = () => {
    checkPayment().catch((error) => {
      console.error('Erro ao verificar pagamento:', error);
    });
  };

  const openBillet = () => {
    if (firstPayment?.boleto?.boletoUrl) {
      window.location.href = firstPayment?.boleto?.boletoUrl;
    }
  };

  useEffect(() => {
    if (device === 'mobile' && firstPayment?.picpay?.paymentURL) {
      window.location.href = firstPayment?.picpay?.paymentURL;
    }
  }, [device, firstPayment]);

  useEffect(() => {
    const hasPixQrCode = (firstPayment?.paymentMethod === 'pix' && firstPayment?.pix?.qrCode) ||
                         (firstPayment?.paymentMethod === 'pix_auto' && (firstPayment?.pix_auto?.qrCode || firstPayment?.pix?.qrCode));

    if (!hasPixQrCode) return;
    if (firstPayment.status !== 'waiting_payment') return;

    const intervalTime = Number(import.meta.env.VITE_PIX_CHECK_INTERVAL || 5000);
    const totalDuration = Number(import.meta.env.VITE_PIX_CHECK_DURATION || 300000);

    const interval = setInterval(() => {
      checkPayment().catch((error) => {
        console.error('Erro no polling automático:', error);
      });
    }, intervalTime);

    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, totalDuration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [firstPayment?.status, firstPayment?.paymentMethod, firstPayment?.pix?.qrCode, firstPayment?.pix_auto?.qrCode, checkPayment]);

  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        numberOfPieces={300}
        gravity={0.6}
        run={true}
        recycle={false}
        tweenDuration={2000}
      />

      <Card
        style={{
          backgroundColor: settings.form?.background.color
        }}
        borderEffect={`${((firstPayment?.paymentMethod === 'pix' && !!firstPayment?.pix?.qrCode) ||
                          (firstPayment?.paymentMethod === 'pix_auto' && !!firstPayment?.pix_auto?.qrCode)) && 'border-wave-effect'}`}
      >
                <div className="flex flex-col gap-3 items-center w-full">
          <section className="flex justify-center w-full gap-3 mt-2">
            {/* Lógica inteligente: mostrar o componente correto baseado no método, mesmo se o QR Code estiver em outro campo */}
            {firstPayment?.paymentMethod === 'pix' && !!firstPayment?.pix?.qrCode && (
              <PixPayment
                qrCode={firstPayment.pix.qrCode}
                status={firstPayment.status}
                checkingPayment={checkingPayment}
                onCheckPayment={handleCheckPayment}
              />
            )}
            {firstPayment?.paymentMethod === 'pix_auto' && (!!firstPayment?.pix_auto?.qrCode || !!firstPayment?.pix?.qrCode) && (
              <PixAutoPayment
                qrCode={(firstPayment.pix_auto?.qrCode || firstPayment.pix?.qrCode) || ''}
                checkingPayment={checkingPayment}
                onCheckPayment={handleCheckPayment}
              />
            )}
            {!!firstPayment?.boleto?.barcode && (
              <BoletoPayment
                barcode={firstPayment.boleto.barcode}
                boletoUrl={firstPayment.boleto.boletoUrl}
                amount={firstPayment.amount}
                expirationDate={firstPayment.boleto.expirationDate}
                onOpenBillet={openBillet}
              />
            )}
            {!!firstPayment?.picpay?.qrCode && (
              <PicPayPayment
                qrCode={firstPayment.picpay.qrCode}
                status={firstPayment.status}
                checkingPayment={checkingPayment}
                onCheckPayment={handleCheckPayment}
              />
            )}
          </section>
        </div>
      </Card>
    </>
  );
};

export default WaitingPayment;
